import type { AuthProvider } from './AuthProvider'
import { MockAuthProvider } from './MockAuthProvider'
import { SupabaseAuthProvider } from './SupabaseAuthProvider'

let instance: AuthProvider | null = null

export function getAuthProvider(): AuthProvider {
  if (instance) return instance
  const which = import.meta.env.VITE_AUTH_PROVIDER ?? 'mock'
  instance = which === 'supabase' ? new SupabaseAuthProvider() : new MockAuthProvider()
  return instance
}

export type { AuthProvider, AuthSession } from './AuthProvider'
